import { z } from 'zod'

export const paramsSchema = z.object({
  path: z.string(),
  parameters: z.string().nullable(),
  totalResults: z.number().nullable(),
})

export type paramsType = z.infer<typeof paramsSchema>
